// import React from 'react'
// import { Link } from 'react-router-dom';
// import PostFeed from '../Group/NormalPost';
// import LinkedInPost from '../Group/LinkedInPost';
// import LinkedInPoll from '../Group/LinkedInPoll';
// const DetailedSavePost = () => {
//   const [isLoading, setIsLoading] = useState(false);
//   return (
//     <>
//       {isLoading ? (
//         <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-10">
//           <img src="/Images/loader.gif" className="h-16 w-16 bg-opacity-50" />
//         </div>
//       ) : (
//         <div className="bg-[#F3F2EF] mt-12 ">
//           <div className=" container mx-auto flex flex-col lg:flex-row py-4 px-4 sm:px-6 lg:px-8">
//             <div className="w-full lg:w-1/4 pt-4 pr-4 ">
//               <div className="bg-white rounded-lg">
//                 <div className="relative">
//                   {bg_profile.current ? (
//                     <img
//                       src={bg_profile.current}
//                       alt="Creative design background"
//                       className="w-full h-28 object-cover rounded-t-lg"
//                     />
//                   ) : (
//                     <img
//                       src={"/Images/cover-img.jpg"}
//                       alt="Creative design background"
//                       className="w-full h-28 object-cover rounded-t-lg"
//                     />
//                   )}

//                   <div className="absolute bottom-4 left-4 transform translate-y-1/2">
//                     {profile.current ? (
//                       <img
//                         src={profile.current}
//                         alt="Profile of Erikson George"
//                         className="size-24 rounded-full border-4 border-white"
//                       />
//                     ) : (
//                       <div className="size-24 rounded-full bg-purple-500 text-white flex items-center justify-center font-semibold text-4xl">
//                         {introformData.name.charAt(0)}
//                       </div>
//                     )}

//                     <button
//                       className="absolute bottom-2 left-[70px] bg-white rounded-full text-2xl text-blue-500"
//                       onClick={openModalProfile}
//                     >
//                       <IoIosAddCircleOutline />
//                     </button>
//                   </div>
//                   {isModalProfile && (
//                     <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-10">
//                       <div className="bg-white shadow-lg rounded-[30px] w-full max-w-2xl mx-auto border-8 border-gray-500">
//                         <div className="flex justify-between items-center bg-gray-200 p-5 rounded-t-[30px]">
//                           <h2 className="text-xl font-semibold">Add photo</h2>
//                           <button
//                             onClick={closeModalProfile}
//                             className="text-gray-500 hover:text-gray-700"
//                           >
//                             <i className="fas fa-times"></i>
//                           </button>
//                         </div>
//                         <div className="px-5 py-4">
//                           <form
//                             onSubmit={handleProfileSubmit}
//                             className="space-y-4"
//                           >
//                             <div className=" flex flex-col items-center p-4 border-2 border-dashed border-gray-300 rounded-lg hover:bg-gray-50 transition">
//                               <input
//                                 key={inputKey}
//                                 type="file"
//                                 id="image"
//                                 accept="image/*"
//                                 className="absolute w-full h-full opacity-0 cursor-pointer"
//                                 onChange={handleImageChange}
//                               />

//                               {pimage && (
//                                 <div className="relative w-full h-96 ">
//                                   <Cropper
//                                     image={pimage}
//                                     crop={crop}
//                                     zoom={zoom}
//                                     aspect={4 / 4}
//                                     onCropChange={setCrop}
//                                     onZoomChange={setZoom}
//                                     onCropComplete={onCropProfileComplete}
//                                   />
//                                   <button
//                                     onClick={saveCroppedProfileImage}
//                                     className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-blue-500 text-white px-4 py-2 rounded"
//                                   >
//                                     Save Cropped Image
//                                   </button>
//                                 </div>
//                               )}

//                               {preview ? (
//                                 <div className="flex flex-col items-center">
//                                   <img
//                                     src={preview}
//                                     alt="Preview"
//                                     className="mt-2 w-40 h-40 object-cover rounded-xl shadow-md border"
//                                   />
//                                 </div>
//                               ) : !pimage ? (
//                                 <>
//                                   <div className=" mb-2 text-4xl text-gray-500 bg-gray-200 p-4 size-40 flex items-center justify-center rounded-md">
//                                     <FaCamera />
//                                   </div>

//                                   <span className="text-gray-500">
//                                     Upload a photo
//                                   </span>
//                                   <p className="text-sm text-gray-600 mt-2">
//                                     Allowed size range: <b>200x200px</b> to{" "}
//                                     <b>1000x1000px</b>
//                                   </p>
//                                 </>
//                               ) : null}
//                             </div>
//                             <button
//                               type="submit"
//                               className="w-full bg-gradient-to-r from-blue-500 to-blue-700 text-white py-2 px-4 rounded-xl font-semibold shadow-md hover:shadow-lg hover:scale-105 transition transform"
//                             >
//                               Upload Image
//                             </button>
//                           </form>
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>

//                 <div className="py-8 px-6">
//                   <div className=" ">
//                     <div className="flex justify-between">
//                       <div className="flex items-center space-x-4 ">
//                         <h1 className="text-xl font-bold">
//                           {introformData.name}
//                         </h1>
//                       </div>
//                     </div>
//                     <p className="text-sm text-gray-700">
//                       {introformData.position}
//                     </p>
//                     <p className="text-[12px] text-gray-500">
//                       {introformData.city}
//                     </p>
//                   </div>
//                   <div className=" flex justify-between items-center mt-2">
//                     <i className="fas fa-building text-2xl text-gray-500 "></i>
//                     <p className="ml-2 text-gray-800 text-sm ">
//                       {experiencedata ? experiencedata[0]?.company : ""}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//               <div className=" flex justify-between p-4 border bg-white rounded-lg mt-2">
//                 <div className="flex flex-col space-y-0">
//                   <p className="text-[14px] ">Connections</p>
//                   <p className=" text-[12px] text-gray-600">
//                     Grow your network
//                   </p>
//                 </div>
//                 <p className="text-[14px] text-blue-600">4</p>
//               </div>
//               <div className="p-4 border bg-white rounded-lg mt-2">
//                 <p className="text-[13px] text-gray-600 ml-1">
//                   Network smarter with Premium
//                 </p>
//                 <div className="flex space-x-1">
//                   <img
//                     src="/Images/newsfeed/Premium.png"
//                     alt="Premium"
//                     className="size-6"
//                   />
//                   <p className="text-[15px] ">Try 1 month of premium for ₹0</p>
//                 </div>
//               </div>
//             </div>
//             <div className="w-full lg:w-2/4 p-4"></div>
//             <div className="w-full lg:w-1/4 p-4 p">
//               <div className=" rounded-lg">
//                 <img
//                   src="/Images/newsfeed/RightBannerCard.png"
//                   alt="Digital Marketing"
//                   className="w-full rounded-lg"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// export default DetailedSavePost

import React, { useState, useEffect, useRef } from "react";
import { Link,useParams } from "react-router-dom";
import PostFeed from "../Group/NormalPost";
import LinkedInPost from "../Group/LinkedInPost";
import LinkedInPoll from "../Group/LinkedInPoll";
import EventPost  from "../Group/EventPost";
import axios from "axios";
import BaseUrl from "../../Components/BaseUrl";
import Cookies from "js-cookie";
import { IoIosAddCircleOutline } from "react-icons/io";

const DetailedSavePost = () => {
  const { id } = useParams();
  const { type } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [posts, setPosts] = useState([]);
  const [user, setUser] = useState({});
  const currentUserRef = useRef({});
  useEffect(() => {
    getUserDetails();
    fetchPosts(type,id);
  }, [id,type]);

  const fetchPosts = async (type,id) => {
    setIsLoading(true);
    try {
      const response = await axios.get(BaseUrl + `saveddetailedpost/${ type}/${id}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      
      setPosts(response.data.data);
    } catch (error) {
      console.error("Error fetching posts:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const getUserDetails = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(BaseUrl + `userdetails`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      setUser(response.data.data);
      currentUserRef.current = {
        profile_image: response.data.data.profile_image,
        name: response.data.data.name,
      };
    } catch (error) {
      console.error("Error fetching user details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const renderPost = (post) => {
    
    console.log(currentUserRef.current);
    switch (post.type) {
      case "post":
        return <PostFeed key={post.id} postData={post} CurrentUser={currentUserRef.current} />;
      case "group_post":
        return <LinkedInPost key={post.id} postData={post} currentUser={currentUserRef.current}/>;
      case "group_poll":
        return <LinkedInPoll key={post.id} pollData={post} currentUser={currentUserRef.current} />;
      case "event":
        return <EventPost key={post.id} postData={post} CurrentUser={currentUserRef.current} />;
      default:
        return null;
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-10">
          <img src="/Images/loader.gif" className="h-16 w-16 bg-opacity-50" />
        </div>
      ) : (
        <div className="bg-[#F3F2EF] h-vh mt-10">
          <div className="container mx-auto flex flex-col lg:flex-row py-4 px-4 sm:px-6 lg:px-8">
            <div className="w-full lg:w-1/4 pt-4 pr-4">
              <div className="bg-white rounded-lg">
                <Link to="/user/userprofile">
                  <div className="relative">
                    {user.cover_image ? (
                      <img
                        src={user.cover_image}
                        alt="Creative design background"
                        className="w-full h-28 object-cover rounded-t-lg"
                      />
                    ) : (
                      <img
                        src={"/Images/cover-img.jpg"}
                        alt="Creative design background"
                        className="w-full h-28 object-cover rounded-t-lg"
                      />
                    )}

                    <div className="absolute bottom-4 left-4 transform translate-y-1/2">
                      {user.profile_image ? (
                        <img
                          src={user.profile_image}
                          alt="Profile of Erikson George"
                          className="size-24 rounded-full border-4 border-white"
                        />
                      ) : (
                        <div className="size-24 rounded-full bg-purple-500 text-white flex items-center justify-center font-semibold text-4xl">
                          {user?.name?.charAt(0)?.toUpperCase()}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="py-8 px-6">
                    <div>
                      <div className="flex justify-between">
                        <div className="flex items-center space-x-4">
                          <h1 className="text-xl font-bold">{user?.name}</h1>
                        </div>
                      </div>
                      <p className="text-sm text-gray-700">{user?.headline}</p>
                      <p className="text-[12px] text-gray-500">{user?.city}</p>
                    </div>
                    {/* <div className="flex justify-between items-center mt-2">
                    <i className="fas fa-building text-2xl text-gray-500"></i>
                    <p className="ml-2 text-gray-800 text-sm">
                      {experiencedata ? experiencedata[0]?.company : ""}
                    </p>
                  </div> */}
                  </div>
                </Link>
              </div>
              <Link
                to="/user/networks"
                className=" flex justify-between p-4 border bg-white rounded-lg mt-2 hover:underline"
              >
                <div className="flex flex-col space-y-0">
                  <p className="text-[14px] ">Connections</p>
                  <p className=" text-[12px] text-gray-600">
                    Grow your network
                  </p>
                </div>
                <p className="text-[14px] text-blue-600">4</p>
              </Link>
              {/* <div className="p-4 border bg-white rounded-lg mt-2">
                <p className="text-[13px] text-gray-600 ml-1">
                  Network smarter with Premium
                </p>
                <div className="flex space-x-1">
                  <img
                    src="/Images/newsfeed/Premium.png"
                    alt="Premium"
                    className="size-6"
                  />
                  <p className="text-[15px]">Try 1 month of premium for ₹0</p>
                </div>
              </div> */}
            </div>
            <div className="w-full lg:w-2/4 py-4">
              {posts ? (
                <div className="space-y-4">{renderPost(posts)}</div>
              ) : (
                <div className="px-4">
                  <p className="text-gray-700 font-semibold mb-1">
                    You haven’t posted yet
                  </p>
                  <p className="text-gray-500 text-sm mb-4">
                    Posts you share will be displayed here.
                  </p>
                </div>
              )}
            </div>
            <div className="w-full lg:w-1/4 p-4">
              <div className="rounded-lg">
                <img
                  src="/Images/newsfeed/RightBannerCard.png"
                  alt="Digital Marketing"
                  className="w-full rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DetailedSavePost;
